import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["postal", "address", "neighborhood", "city", "state"];

	disconnect() {
		this.abortController?.abort();
	}

	async lookup() {
		const digits = this.postalTarget.value.replace(/\D/g, "");
		if (digits !== this.lastDigits) {
			const hadCompletePostalCode = this.lastDigits?.length === 8;
			this.lastDigits = digits;
			this.abortController?.abort();
			this.clearAutofilledTargets();
			this.dispatch("loading", { bubbles: true });
			if (digits.length !== 8) {
				if (hadCompletePostalCode) this.dispatch("filled", { bubbles: true });
				return;
			}
		}

		if (digits.length !== 8) return;
		this.abortController = new AbortController();
		const { signal } = this.abortController;

		try {
			const response = await fetch(`/loja/cep/${digits}`, { signal });
			if (response.ok && digits === this.lastDigits) this.fill(await response.json());
		} catch {
		} finally {
			if (!signal.aborted && digits === this.lastDigits) this.dispatch("filled", { bubbles: true });
		}
	}

	fill(data) {
		this.fillTarget(this.addressTarget, data.address);
		this.fillTarget(this.neighborhoodTarget, data.neighborhood);
		this.fillTarget(this.cityTarget, data.city);
		this.fillTarget(this.stateTarget, data.state);
	}

	fillTarget(target, value) {
		if (!target.value && value) {
			target.value = value;
			target.dataset.cepLookupValue = value;
		}
	}

	clearAutofilledTargets() {
		[this.addressTarget, this.neighborhoodTarget, this.cityTarget, this.stateTarget].forEach((target) => {
			if (target.dataset.cepLookupValue && target.value === target.dataset.cepLookupValue) target.value = "";
			delete target.dataset.cepLookupValue;
		});
	}
}
